export default __webpack_public_path__ + "static/media/avatar9.cf29cbdd.svg";